export const getAllRestaurants = "vendor/get-vendors/";
export const addRestaurant = "vendor/create-vendor/";
export const editRestaurant = "vendor/edit-vendor/";
export const getDeliveriesUsers = "delivery/get-deliveries";
export const addDeliveryUser = "delivery/create-delivery";
export const getAdmins = "admin/get-admins";
export const addAdmin = "admin/create-admin";
export const deleteUser = "user/delete";
export const adminLogin = "admin/login/";
export const refreshTokenUrl = "api/auth/refresh";
export const logoutUrl = "user/logout";
export const getCategoreis = "api/category";
export const addCategory = "api/category";
export const deleteCategory = "api/category/";
export const editCategory = "api/category/";
export const updatedAdminRole = "admin/updated-roles";
export const getAllProducts = "api/product";
export const deleteProduct = "api/product/";
export const editProduct = "api/product/";
export const editAdmin = "admin/update-admin";
export const editDeliveryUser = "user/update";
export const createProduct = "api/product";
export const getProductById = "api/product/";
export const deleteProductImage = "api/productImage/";
export const addDeliveryCostForVendor = "api/costs";
export const getDeliveryArea = "api/area";
export const deleteDeliveryCosy = "api/costs/";
export const editDeliveryCost = "api/costs/";
export const deleteDeliveryArea = "api/area/";
export const createDeliveryArea = "api/area";
export const editDeliveryArea = "api/area/";
export const deleteProductOptionById = "api/option/";
export const deleteoptionsGroupById = "api/group/";
export const addProductGroupOption = "api/group";
export const editProductOption = "api/option/";
export const editProductGroup = "api/group/";
export const getSliderData = "api/slider";
export const deleteSlider = "api/slider/";
export const addSlider = "api/slider";
export const editSlider = "api/slider/";
export const toggleSliderHidden = "api/slider/";
export const getOrders = "api/order";
export const deleteOrder = "api/order/";
export const getOrderDetails = "api/order/";
export const createCommonGroup = "api/group";
export const getAllUsers = "user/all-users";
export const getNotifications = "api/user-notifications/";
export const getStatistics = "api/numbers/";
export const getProfile = "user/profile/";
export const updateUser = "user/update/";
export const deleteAllVendorProducts = "api/product/vendor/";
export const toggleBlockUser = "user/toggle-block";
export const updateUserNote = "user/note";
export const getDeliveryOffersData = "api/delivery-offers";
export const addDeliveryOffer = "api/delivery-offers";
export const editDeliveryOffer = "api/delivery-offers/";
export const deleteDeliveryOffer = "api/delivery-offers/";
export const adminChangeUserPassword = "user/admin-change-password";
export const impersonateUser = "admin/impersonate";
export const getAppVersions = "api/app-versions";
export const updateAppVersion = "api/app-versions/";
export const getMessagingHealth = "api/messaging-health";
